import CssBaseline from "@material-ui/core/CssBaseline";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { AppProps, default as NextApp, DefaultAppIProps, NextAppContext } from "next/app";
import React from "react";
import JssProvider from "react-jss/lib/JssProvider";

import { getPageContext, MaterialUIPageContext } from "./pageContext";

interface IProps extends DefaultAppIProps, AppProps {}

export const withMaterialUIProvider = (App: typeof NextApp) => {
  return class WithMaterialUIProvider extends App<IProps> {
    public static async getInitialProps(appContext: NextAppContext) {
      const appProps = App.getInitialProps
        ? await App.getInitialProps(appContext)
        : { pageProps: {} };

      return { ...appProps };
    }

    private pageContext: MaterialUIPageContext;

    constructor(props: IProps) {
      super(props);
      this.pageContext = getPageContext();
    }

    public componentDidMount() {
      // Remove the server-side injected CSS.
      const jssStyles = document.querySelector("#jss-server-side");
      if (jssStyles && jssStyles.parentNode) {
        jssStyles.parentNode.removeChild(jssStyles);
      }
    }

    public render() {
      return (
        <JssProvider
          registry={this.pageContext.sheetsRegistry}
          generateClassName={this.pageContext.generateClassName}
        >
          {/* MuiThemeProvider makes the theme available down the React
              tree thanks to React context. */}
          <MuiThemeProvider
            theme={this.pageContext.theme}
            sheetsManager={this.pageContext.sheetsManager}
          >
            {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
            <CssBaseline />
            {/* Pass pageContext to the _document though the renderPage enhancer
                to render collected styles on server side. */}
            <App {...this.props} pageContext={this.pageContext} />
          </MuiThemeProvider>
        </JssProvider>
      );
    }
  };
};
